"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MoreHoriz_1 = __importDefault(require("@mui/icons-material/MoreHoriz"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const formatBillingAddress = ({ addressLine1, city, region, zipCode } = appConstants_1.emptyBillingAddress) => {
    if (addressLine1 === null || addressLine1 === undefined || addressLine1 === '') {
        return '';
    }
    return `${addressLine1}\n${city}, ${region} ${zipCode}`;
};
const useGetTableData = (isTeamCards) => {
    const { setCardSourceId, setIsCardSourceDetailOpen, setCompanyCards } = (0, zustandStore_1.useZustand)();
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const currentTeamId = teamId?.[0] || '';
    const { data: companyCards, isLoading: isLoadingGetCompanyCards } = (0, paymentQuery_1.useGetCompanyCardSourcesQuery)({
        ...paymentQuery_1.paymentParams,
        isEnabled: !isTeamCards,
    });
    const { data: teamCards, isLoading: isLoadingGetTeamsCards } = (0, paymentQuery_1.useGetTeamCardSourcesQuery)({
        ...paymentQuery_1.paymentParams,
        teamId: currentTeamId,
        isEnabled: isTeamCards,
    });
    const { data: currencies } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(isTeamCards ? currentTeamId : undefined));
    const cardSourceId = (0, zustandStore_1.useZustand)(state => state.payment.cardSourceId);
    const cardSources = isTeamCards ? teamCards || [] : companyCards || [];
    (0, react_1.useEffect)(() => {
        if (!companyCards) {
            return;
        }
        setCompanyCards(companyCards);
    }, [companyCards, setCompanyCards]);
    const toggleCardDetailsAside = ({ value, id = '', setIsCardSourceDetailOpen }) => {
        setIsCardSourceDetailOpen({ isOpen: value, cardSourceId: id || cardSourceId });
    };
    const cardsData = cardSources && cardSources.length > 0
        ? cardSources.map(cardSource => {
            const cardCurrency = cardSource.billingCurrency || cardSource.currency || currencies?.[0] || 'N/A';
            return [
                {
                    id: 'cardName',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardSource?.name || '' });
                    },
                },
                {
                    id: 'provider',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardSource?.providerLabel || '' });
                    },
                },
                {
                    id: 'lastFourDigits',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardSource?.lastDigits || '' });
                    },
                },
                {
                    id: 'currency',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardCurrency });
                    },
                },
                {
                    id: 'status',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: [
                                lodash_1.default.lowerCase(cardSource.status) === lodash_1.default.lowerCase(appConstants_1.cardsourceStatus.ACTIVE)
                                    ? {
                                        color: 'inherit',
                                    }
                                    : {
                                        color: 'orange',
                                    },
                            ], variant: "body1", children: appConstants_1.cardsourceStatus[cardSource.status] || '' }));
                    },
                },
                {
                    id: 'adddress',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardSource.billingAddress ? formatBillingAddress(cardSource.billingAddress) : '' }));
                    },
                },
                {
                    id: 'teams',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: cardSource.teamsCount || '' });
                    },
                },
                {
                    id: 'details',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                                justifyContent: 'flex-end',
                                alignItems: 'flex-end',
                            }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "text", "ts-variant": "actionButton", onClick: () => {
                                    setCardSourceId(cardSource.id);
                                    toggleCardDetailsAside({
                                        value: true,
                                        id: cardSource.id,
                                        setIsCardSourceDetailOpen,
                                    });
                                }, children: (0, jsx_runtime_1.jsx)(MoreHoriz_1.default, {}) }) }));
                    },
                },
            ];
        })
        : [];
    return { cardsData, isLoading: isLoadingGetCompanyCards || isLoadingGetTeamsCards };
};
exports.useGetTableData = useGetTableData;
